module.exports = __webpack_public_path__ + "static/media/lock-icon.0307dee5.svg";